import React, { useState, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Button, Chip, FormControlLabel, Grid, IconButton, Snackbar, Tooltip, Typography } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import InputSwitch from '@material-ui/core/Switch';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import GearIcon from '../icons/GearIcon';
import HintIcon from '../icons/HintIcon';
import CloseIcon from "../icons/CloseIcon";
import translate from '../other/translate.json';
import { FullscreenExitRounded } from "@material-ui/icons";

export default function SnackbarCookies(props) {
	const classes = useStyles();
	const cookieMessage = props.language === 'Ru'
		?
		<Typography variant="p" className={classes.pCookie}>
			Мы используем cookies для работы сайта и аналитики с помощью Яндекс.Метрики. Вы можете принять все, настроить или отклонить cookies. Подробнее — в <a href="https://www.cft.ru/sites/cft/Documents/Politics.pdf" className={classes.LinkType11}>Политике конфиденциальности</a>.
		</Typography>
		:
		<Typography variant="p" className={classes.pCookie}>
			We use cookies to operate our website and for analytics using Yandex.Metrica. You can accept all cookies, configure settings, or reject them. For more information, see the <a href="https://www.cft.ru/sites/cft/Documents/Politics.pdf" className={classes.LinkType11}>Privacy Policy</a>.
		</Typography>

	return (
		<Snackbar
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'center',
			}}
			open={props.openSnackbar}
			className={classes.snackbarRoot}
		>
			<div className={classes.snackbarPostroot}>
				<Grid container style={{ display: props.altCookieSnackbar ? 'none' : props.cookies1 }}>
					{cookieMessage}

					<Grid item container spacing={2} className={classes.cntrAction}>
						<Grid item style={{ width: window.innerWidth < 696 ? '100%' : null }}>
							<Button
								style={{ backgroundColor: '#FFF', color: '#8987A2', lineHeight: '36px', minHeight: '56px' }}
								variant="contained"
								color="default"
								className={classes.snackbarBtn}
								startIcon={<GearIcon />}
								onClick={() => { props._cookies1('none'); props._cookies2('block') }}
							>
								{props.language === 'Ru' ? translate.CookiesSnackbar.SettingsBtn_Ru : translate.CookiesSnackbar.SettingsBtn_En}
							</Button>
						</Grid>

						<Grid item style={{ width: window.innerWidth < 696 ? '100%' : null }}>
							<Button
								style={{ padding: '6px 38px 6px 30px', backgroundColor: '#EB505E', color: '#FFF', lineHeight: '44px' }}
								variant="contained"
								color="default"
								className={classes.snackbarBtn}
								startIcon={<HighlightOffIcon />}
								onClick={() => { if (props.snackbarMessage === null) { props.setCookie(false, false) } else { props.handleCloseSnackbar() } }}
							>
								{props.language === 'Ru' ? "Не разрешать" : "Forbidden all"}
							</Button>
						</Grid>

						<Grid item style={{ width: window.innerWidth < 696 ? '100%' : null }}>
							<Button
								style={{ padding: '6px 38px 6px 30px', backgroundColor: '#EB505E', color: '#FFF', lineHeight: '44px' }}
								variant="contained"
								color="default"
								className={classes.snackbarBtn}
								startIcon={<CheckIcon />}
								onClick={() => { if (props.snackbarMessage === null) { props.setCookie(true, false) } else { props.handleCloseSnackbar() } }}
							>
								{props.language === 'Ru' ? translate.CookiesSnackbar.AllowAllBtn_Ru : translate.CookiesSnackbar.AllowAllBtn_En}
							</Button>
						</Grid>
					</Grid>
				</Grid>

				<Grid container style={{ display: props.altCookieSnackbar ? 'block' : props.cookies2, paddingTop: 2 }}>
					{props.altCookieSnackbar
						?
						<Grid item style={{ position: 'absolute', right: '30px' }}>
							<IconButton onClick={() => props.handleCloseSnackbar()} aria-label="closeSnackbar">
								<CloseIcon fill='#BCBBD0' />
							</IconButton>
						</Grid>
						:
						null
					}

					<Grid item container direction="column" spacing={2}>
						<Grid item>
							{props.altCookieSnackbar
								?
								null
								:
								<Chip size="small" icon={<ArrowBackIcon style={{ color: '#BCBBD0' }} />} label={props.language === 'Ru' ? "Cookie-файлы" : "Cookies"} onClick={() => { props._cookiesAnalitycs(false); props._cookies1('block'); props._cookies2('none') }} style={{ backgroundColor: 'transparent', color: '#BCBBD0', fontSize: '18px' }} />
							}
						</Grid>

						<Grid item component={'h2'} className={classes.snackbarHeader}>{props.language === 'Ru' ? translate.CookiesSnackbar.SettingsBtn_Ru : translate.CookiesSnackbar.SettingsBtn_En}</Grid>

						<Grid item container direction="column" spacing={2} style={{ paddingLeft: window.innerWidth < 696 ? 12 : null }}>
							<Grid item container direction="row" style={{ justifyContent: "space-between", height: window.innerWidth < 696 ? 68 : null }}>
								<Grid item>
									{window.innerWidth < 696 ?
										<FormControlLabel
											control={<CatalogSwitch size="small" checked={true} disabled /* onChange={toggleChecked} */ />}
											label={<span className={classes.snackbarControlLabel} style={{ paddingLeft: window.innerWidth < 696 ? 2 : 8 }}>Обязательные</span>}
										/>
										:
										<FormControlLabel
											control={<CatalogSwitch checked={true} disabled /* onChange={toggleChecked} */ />}
											label={<span className={classes.snackbarControlLabel}>
												{props.language === 'Ru' ? translate.CookiesSnackbar.Required_Ru : translate.CookiesSnackbar.Required_En}
											</span>}
										/>
									}
								</Grid>

								<Grid item container direction="row" sm className={classes.snackbarHintCntr}>
									<Grid item component={'p'} style={{ fontFamily: 'Cera CY', fontWeight: 400, fontStyle: 'Regular', fontSize: '16px', lineHeight: '24px', textAlign: 'right', color: '#BCBBD0', paddingRight: 10 }}>
										{props.language === 'Ru' ? translate.CookiesSnackbar.AlwaysAllowed_Ru : translate.CookiesSnackbar.AlwaysAllowed_En}
									</Grid>

									<Tooltip title={props.language === 'Ru' ? "Строго необходимы для просмотра содержимого сайта и получения доступа к его функционалу." : "Strictly necessary for viewing the site's content and accessing its functionality."}>
										<Grid item>
											<HintIcon fill={'#BCBBD0'} />
										</Grid>
									</Tooltip>
								</Grid>
							</Grid>

							<Grid item container direction="row" style={{ justifyContent: "space-between", height: window.innerWidth < 696 ? 68 : null }}>
								<Grid item>
									{window.innerWidth < 696 ?
										<FormControlLabel
											control={<CatalogSwitch size="small" /* checked={checked} onChange={toggleChecked} */ />}
											label={<span className={classes.snackbarControlLabel} style={{ paddingLeft: window.innerWidth < 696 ? 2 : 8 }}>
												{props.language === 'Ru' ? translate.CookiesSnackbar.AllowAllBtn_Ru : translate.CookiesSnackbar.AllowAllBtn_En}
											</span>}
										/>
										:
										<FormControlLabel
											control={<CatalogSwitch checked={props.cookiesAnalitycs} onChange={() => props._cookiesAnalitycs(!(props.cookiesAnalitycs))} />}
											label={<span className={classes.snackbarControlLabel}>
												{props.language === 'Ru' ? translate.CookiesSnackbar.Analytical_Ru : translate.CookiesSnackbar.Analytical_En}
											</span>}
										/>
									}
								</Grid>

								<Grid item container direction="row" sm className={classes.snackbarHintCntr}>
									<Grid item component={'p'} style={{ fontFamily: 'Cera CY', fontWeight: 400, fontStyle: 'Regular', fontSize: '16px', lineHeight: '24px', textAlign: 'right', color: '#BCBBD0', paddingRight: 10 }}>
										{props.language === 'Ru' ? props.cookiesAnalitycs ? translate.CookiesSnackbar.Allowed_Ru : translate.CookiesSnackbar.Forbidden_Ru : props.cookiesAnalitycs ? translate.CookiesSnackbar.Allowed_En : translate.CookiesSnackbar.Forbidden_En}
									</Grid>

									<Tooltip title={props.language === 'Ru' ? "Собирают обезличенную статистическую информацию о том, как пользователи взаимодействуют с Сайтом (можно отключить)" : "Collect anonymous statistical information about how users interact with the Site (can be disabled)"}>
										<Grid item>
											<HintIcon fill={'#BCBBD0'} />
										</Grid>
									</Tooltip>
								</Grid>
							</Grid>

							{/* <Grid item container direction="row" style={{ justifyContent: "space-between", height: window.innerWidth < 696 ? 68 : null }}>
								<Grid item>
									{window.innerWidth < 696 ?
										<FormControlLabel
											control={<CatalogSwitch size="small" checked={checked} onChange={toggleChecked} />}
											label={<span className={classes.snackbarControlLabel} style={{ paddingLeft: window.innerWidth < 696 ? 2 : 8 }}>Маркетинговые</span>}
										/>
										:
										<FormControlLabel
											control={<CatalogSwitch checked={checked} onChange={toggleChecked} />}
											label={<span className={classes.snackbarControlLabel}>Маркетинговые</span>}
										/>
									}
								</Grid>

								<Grid item container direction="row" sm className={classes.snackbarHintCntr}>
									<Grid item component={'p'} style={{ fontFamily: 'Cera CY', fontWeight: 400, fontStyle: 'Regular', fontSize: '16px', lineHeight: '24px', textAlign: 'right', color: '#BCBBD0', paddingRight: 10 }}>Запрещено</Grid>

									<Grid item>
										<HintIcon fill={'#BCBBD0'} />
									</Grid>
								</Grid>
							</Grid> */}
						</Grid>
					</Grid>

					<Grid item container spacing={2} className={classes.cntrAction} style={{ marginTop: 17 }}>
						{props.altCookieSnackbar
							?
							null
							:
							<Grid item style={{ width: window.innerWidth < 696 ? '100%' : null }}>
								<Button
									style={{ padding: window.innerWidth < 696 ? '7px 26px 6px 30px' : '7px 26px 6px 23px', backgroundColor: '#FFF', color: '#8987A2', lineHeight: '36px', minHeight: '56px' }}
									variant="contained"
									color="default"
									className={classes.snackbarBtn}
									startIcon={<ArrowBackIcon />}
									onClick={() => { props._cookiesAnalitycs(false); props._cookies1('block'); props._cookies2('none') }}
								>
									{props.language === 'Ru' ? translate.CookiesSnackbar.BackBtn_Ru : translate.CookiesSnackbar.BackBtn_En}
								</Button>
							</Grid>
						}

						<Grid item style={{ width: window.innerWidth < 696 ? '100%' : null }}>
							<Button
								style={{ padding: window.innerWidth < 696 ? '6px 37px 6px 42px' : '6px 37px 6px 36px', backgroundColor: '#EB505E', color: '#FFF', lineHeight: '44px' }}
								variant="contained"
								color="default"
								className={classes.snackbarBtn}
								startIcon={<CheckIcon />}
								onClick={() => { if (props.snackbarMessage === null) { props.setCookie(false, true) } else { props.handleCloseSnackbar() } }}
							>
								{props.language === 'Ru' ? translate.CookiesSnackbar.Confirm_Ru : translate.CookiesSnackbar.Confirm_En}
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</div>
		</Snackbar >
	);
}

const CatalogSwitch = withStyles({
	switchBase: {
		color: "#EBEEFF",
		'&$checked': {
			color: "#EB505E",
		},
		'&$checked + $track': {
			backgroundColor: "#F3969E",
		},
	},
	checked: {},
	track: {},
})(InputSwitch);

const useStyles = makeStyles(theme => ({
	root: {
		display: 'flex'
	},

	snackbarRoot: {
		left: 'auto',
		right: 40,
		bottom: 40,
		width: 758,
		transform: 'none',

		[theme.breakpoints.down(696)]: {
			width: 360,
			right: 0,
			bottom: 0,
		},
	},

	snackbarPostroot: {
		padding: '24px 32px',
		alignItems: 'center',
		borderRadius: '16px',
		background: 'rgba(60, 60, 86, 0.9)',
		width: '100%',
		display: 'flex',
		flexWrap: 'wrap',
		boxSizing: 'borderBox',

		[theme.breakpoints.down(696)]: {
			padding: '24px 24px 24px 24px',
			borderBottomRightRadius: 0,
			borderBottomLeftRadius: 0,
		},
	},

	snackbarHeader: {
		color: '#FFF',
		fontWeight: 500,
		fontSize: '28px',
		lineHeight: '42px',

		[theme.breakpoints.down(696)]: {
			color: '#FFF',
			fontWeight: 500,
			fontSize: '22px',
			lineHeight: '30px',
		},
	},

	snackbarHintCntr: {
		justifyContent: 'flex-end',
		alignContent: 'center',

		[theme.breakpoints.down(696)]: {
			justifyContent: 'unset',
			marginLeft: 32,
		},
	},

	cntrAction: {
		marginTop: 37,
		placeContent: 'end',

		[theme.breakpoints.down(696)]: {
			marginTop: 24,
			placeContent: 'center',
			flexDirection: 'column',
			alignItems: 'stretch',
		},
	},

	snackbarBtn: {
		borderRadius: '48px',
		boxShadow: 'none',
		fontSize: '18px',
		fontWeight: 500,
		fontFamily: 'Cera CY',
		textTransform: 'unset',

		[theme.breakpoints.down(696)]: {
			width: '100%',
		}
	},

	snackbarControlLabel: {
		color: '#FFF',
		fontSize: '20px',
		fontWeight: 500,

		[theme.breakpoints.down(696)]: {
			color: '#FFF',
			fontSize: '18px',
			fontWeight: 500,
		}
	},

	LinkType11: {
		color: 'inherit',
		textDecoration: 'none',
		borderBottom: '1px solid',
		borderColor: 'inherit',

		'&:hover': {
			color: '#86B6FF',
			textDecoration: 'none',
			borderBottom: '1px solid #86B6FF',
		}
	},

	pCookie: {
		maxWidth: 818,
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '18px',
		lineHeight: '28px',
		color: '#FFFFFF',

		[theme.breakpoints.down(696)]: {
			fontWeight: '400',
			fontSize: '14px',
			lineHeight: '18px',
		},
	},
}));
